import { Component, OnInit } from '@angular/core';
import { mywalletstore } from '../../../_services/mywallet/store/mywallet.store.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
@Component({
  selector: 'app-storemap',
  templateUrl: './storemap.component.html',
  styleUrls: ['./storemap.component.css']
})
export class StoremapComponent implements OnInit {
  mapMarker: any = {};
  constructor(private storeservice: mywalletstore, public utilserv: utilityService) {}

  ngOnInit() {
    const callSetStore = this.storeservice.getStoreData().subscribe(data => {
      this.mapMarker = this.utilserv.getArray(data);
      if (callSetStore !== undefined) {
        callSetStore.unsubscribe();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/mywallet/store/storemap/storemap.component.ts